import { businessPlanAxios } from 'services/controllers/businessPlan';

import * as t from './types';

export const BusinessPlanFilesApi = {
  getS3UploadLink: async (params: t.IFilePayload) => {
    const { id, filePayload } = params;

    const { data } = await businessPlanAxios.post<t.IS3LinkFileResponse>(`${id}/upload/start`, filePayload);
    return data;
  },

  completeFileUpload: async (params: t.ICompleteFileUploadPayload) => {
    const { id, fileUuid } = params;

    const { data } = await businessPlanAxios.post<t.ICompleteFileUploadResponse>(`${id}/upload/${fileUuid}/complete`);
    return data;
  },

  deleteFile: async (params: t.IDeleteFilePayload) => {
    const { id, fileUuid } = params;

    await businessPlanAxios.delete(`${id}/files/${fileUuid}`);
  },
};
